/* AYS Showcase: opens any element with data-ays-zoom="<image url>" in the shared lightbox. */
(function () {
  if (window.aysShowcaseZoom) return;
  window.aysShowcaseZoom = true;
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ays-zoom]');
    if (!trigger) return;
    var dialog = document.getElementById('ays-shared-dialog');
    var image = document.getElementById('ays-lightbox-img');
    if (!dialog || !image) return;
    image.src = trigger.getAttribute('data-ays-zoom');
    image.alt = trigger.getAttribute('data-ays-zoom-alt') || '';
    dialog.showModal();
  });
})();
